import React from 'react';
/**
 * Vertical spacer and a drop target. Calculates spacing to use depending on the first and last flags.
 */
export const DropTargetSpacer = (props) => {
    let rootPaddingTop = props.spacing / 2;
    let rootPaddingBottom = props.spacing / 2;
    let containerPaddingTop = props.spacing / 2;
    let containerPaddingBottom = props.spacing / 2;
    let placeholderPaddingTop = props.spacing / 2;
    let placeholderPaddingBottom = props.spacing / 2;
    if (props.first && props.last) {
        rootPaddingTop = 0;
        rootPaddingBottom = 0;
        containerPaddingTop = 0;
        containerPaddingBottom = 0;
        placeholderPaddingTop = 0;
        placeholderPaddingBottom = 0;
    }
    else if (props.first) {
        rootPaddingTop = 0;
        rootPaddingBottom = 0;
        containerPaddingTop = 0;
        containerPaddingBottom = props.spacing;
        placeholderPaddingTop = 0;
        placeholderPaddingBottom = props.spacing;
    }
    else if (props.last) {
        rootPaddingTop = 0;
        rootPaddingBottom = 0;
        containerPaddingTop = props.spacing;
        containerPaddingBottom = 0;
        placeholderPaddingTop = props.spacing;
        placeholderPaddingBottom = 0;
    }
    return (React.createElement("div", { "data-drag-target": true, "data-editor-path": props.editorPath, style: { paddingTop: rootPaddingTop, paddingBottom: rootPaddingBottom } },
        React.createElement("div", { "data-drag-target-container": true, style: { display: 'none', paddingTop: containerPaddingTop, paddingBottom: containerPaddingBottom } }),
        props.placeholderElement != null && (React.createElement("div", { "data-drag-target-placeholder": true, style: { display: 'block', paddingTop: placeholderPaddingTop, paddingBottom: placeholderPaddingBottom } }, props.placeholderElement))));
};
